import { getBaseUrl } from "./baseUrl";
import { authFetch } from "./apiFetch";

/**
 * Session from distribution API (verified Firebase token).
 * @returns {Promise<{ uid: string | null, isAdmin: boolean }>}
 */
export async function fetchMe() {
  const base = getBaseUrl();
  if (!base) return { uid: null, isAdmin: false };
  try {
    const res = await authFetch(`${base}/me`);
    if (!res.ok) return { uid: null, isAdmin: false };
    const data = await res.json();
    return {
      uid: data.uid ?? null,
      isAdmin: Boolean(data.isAdmin),
    };
  } catch {
    return { uid: null, isAdmin: false };
  }
}
